module.exports = __webpack_public_path__ + "static/media/atee_bloc_link_1.f3289327.jpg";